<template>
  <Intro />
  <PatientExp />
  <WhatWeDo />
  <ContactUs />
</template>

<script setup lang="ts">
import Intro from "@/components/patients/PatientsIntro.vue";
import WhatWeDo from "@/components/patients/PatientsWhatWeDo.vue";
import PatientExp from "@/components/patients/PatientExp.vue";
import ContactUs from "@/components/shared/footer/ContactUs.vue";

import { computed, onMounted, ref, toRefs } from "vue";

onMounted(async () => {
  //debugger;
  // window.scrollTo(0, 0);
});
</script>

